module.exports = __webpack_public_path__ + "img/gmail.a84dc277.png";